enum PageUrl {
  Home = "home",
  Flights = "flights",
  Baggage = "baggage",
  Passenger = "pax",
  ResourceAllocation = "resource-allocation",
  Weather = "weather",
  EventManagement = "event-management",
  ApplicationSettings = "application-settings",
  Notifications = "notifications",
  Admin = "admin",
  MultiAirports = "multi-airports",
  SingleFlightView = "single-flight-view",
  Overview = "home",
}

enum BreadcrumbEnum {
  Overview = "Overview",
  Flights = "Flights",
  Baggage = "Baggage",
  Passenger = "Passenger",
  ResourceAllocation = "Resource Allocation",
  Weather = "Weather",
  EventManagement = "Event Management",
  ApplicationSettings = "Application Settings",
  Notifications = "Notifications",
  Admin = "Admin",
}

// Temporary code to restrtict YQB to only see certain pages
export enum BreadcrumbEnumYQB {
  Overview = "Overview",
  Flights = "Flights",
  Weather = "Weather",
  Notifications = "Notifications",
  ApplicationSettings = "Application Settings",
}

const PageEnum = {
  PageUrl,
  BreadcrumbEnum,
};

export default PageEnum;
